import { render, staticRenderFns } from "./RoleField.vue?vue&type=template&id=685ce3a6&"
import script from "./RoleField.vue?vue&type=script&lang=js&"
export * from "./RoleField.vue?vue&type=script&lang=js&"
import style0 from "./RoleField.vue?vue&type=style&index=0&id=685ce3a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports